import { render, staticRenderFns } from "./editItem.vue?vue&type=template&id=6e8c7378&scoped=true&"
import script from "./editItem.vue?vue&type=script&lang=js&"
export * from "./editItem.vue?vue&type=script&lang=js&"
import style0 from "./editItem.vue?vue&type=style&index=0&id=6e8c7378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c7378",
  null
  
)

export default component.exports